import { render, staticRenderFns } from "./AvailabilityCollectionTable.vue?vue&type=template&id=171742c3&scoped=true&"
import script from "./AvailabilityCollectionTable.vue?vue&type=script&lang=js&"
export * from "./AvailabilityCollectionTable.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityCollectionTable.vue?vue&type=style&index=0&id=171742c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171742c3",
  null
  
)

export default component.exports